__turbopack_context__.v({
  "tableBorder": "Table-module-scss-module__0RHrnq__tableBorder",
  "tableCellDividers": "Table-module-scss-module__0RHrnq__tableCellDividers",
  "tableHover": "Table-module-scss-module__0RHrnq__tableHover",
  "tableRounded": "Table-module-scss-module__0RHrnq__tableRounded",
  "tableRowDividers": "Table-module-scss-module__0RHrnq__tableRowDividers",
  "tableStrokedHorizontal": "Table-module-scss-module__0RHrnq__tableStrokedHorizontal",
});
